import queryString from "query-string";

import {
    GET_PROJECT_ROLE
} from "@/api/master-data/project-role/project-role";

const state = {
    projectRole: [],
};

const mutations = {
    setProjectRole: (states, payload) => {
        states.projectRole = payload;
    },
};

const actions = {
    getProjectRole: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_PROJECT_ROLE(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setProjectRole", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setProjectRole", []);
            }
            throw err;
        }
    },
};

const getters = {
    ProjectRole: (states) => states.projectRole,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};